import { SmartphoneDevice } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconSmartphoneDevice12Line = createIcon(
  SmartphoneDevice,
  12,
  "Line"
);
export const IconSmartphoneDevice16Line = createIcon(
  SmartphoneDevice,
  16,
  "Line"
);
export const IconSmartphoneDevice20Line = createIcon(
  SmartphoneDevice,
  20,
  "Line"
);
export const IconSmartphoneDevice24Line = createIcon(
  SmartphoneDevice,
  24,
  "Line"
);
export const IconSmartphoneDevice32Line = createIcon(
  SmartphoneDevice,
  32,
  "Line"
);
export const IconSmartphoneDevice48Line = createIcon(
  SmartphoneDevice,
  48,
  "Line"
);
export const IconSmartphoneDevice64Line = createIcon(
  SmartphoneDevice,
  64,
  "Line"
);
